/**************************************************************
Hawaiian Macadamia Nut Services
12.18.18
Mechanical Harvest & Report actions
11.17.22: Updating mech harvest form for multiple entries with
one submission
**************************************************************/
import { 
  SELECT_FIELD, 
  CREATE_MECH_HARVEST, 
  FETCH_MECH_HARVEST, 
  PREPARE_MECH_HARVEST_TO_CREATE,
  PREPARE_MECH_HARVEST_TO_CREATE_2,
  PREPARE_MECH_HARVEST_TO_EDIT,
  PREPARE_MECH_HARVEST_TO_EDIT_2, 
  SET_REPORT_OPTS, 
  SELECT_REPORT_TYPE, 
  FETCH_REPORT,
  SELECT_NEW_REPORT, 
  FETCH_MY_MECH_HARVEST, 
  SELECT_HARVEST_TO_MANAGE, 
  RESET_MANAGE_HARVEST,
  FETCH_HARVEST_BY_DATE, 
  EDIT_MECH_HARVEST, 
  DELETE_MECH_HARVEST, 
  ERROR, 
  ADD_HARVEST_RECORD,
  SET_MECH_HARVEST_TO_EDIT,
  EDIT_MECH_HARVEST_RECORD,
  DELETE_MECH_HARVEST_RECORD  
} from './types';
import { 
  acresPerHour, 
  density, 
  estimatedLbs, 
  acresCompleted, 
  acresBalance, 
  handleInterval,
  percentComplete 
} from '../harvest_utils';
import { batchAcresBalances, seasonForLocation } from '../mech_harvest_calc';
import { error } from './index';
import { 
  clearForm, 
  handleEquipmentNo, 
  findEmployeeByName, 
  determineReportOpts,
  fillEdit,
  fillEdit2,
  generateGUID 
} from '../utils';
import { ROOT_URL } from '../constants';
import axios from 'axios';
import moment from 'moment';
//const FileSaver = require('file-saver');
const Materialize = window.Materialize;
const $ = window.$;
/********************** Asynchronous Function *********************************/
/**
* fetchAllMechHarvest(): Fetches mechanical harvest, equipment, season and employees
* @returns {Object} harvest, equipment, season, employee
* @called-in: ['/components/harvest/view/harvest_view.js']
**/
export function fetchAllMechHarvest() {
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchMechHarvest`, {
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => JSON.parse(res.request.response))
      .then((res) => {
        $('#preloader').css('display','none');
        dispatch({ type: FETCH_MECH_HARVEST, mechHarvest: res.mechHarvest, equipmentNo: res.equipmentNo,
          seasons: res.seasons, employees: res.employees, fields: res.fields });
      }).catch((err) => dispatch(error(`There was an error creating a mechanical harvest. Please try again.`)));
  }
}

/**
* createMechHarvest(): Creates a Mech harvest record
* @param {Object} harvest: harvest record to be created
* @param {Array} previousHarvest: previous harvest records for the field, round, season
* @param {Object} selectedField: Field where harvest is taking place
* @param {Object} equipmentNo: List of available equipment
* @returns {Object} harvest: New harvest record sent back to add to existing records
* @called-in: ['/components/harvest/create/mechHarvest_create.js']
**/
export function createMechHarvest(harvest, previousHarvest, selectedField, equipmentNo) {
  for (let key in harvest) {
    switch (true) {
      case (key === 'block'):
        break;
      case (key !== 'block' && harvest[key] === ''):
        return error('Please complete the entire form.');
      default:
    }
  }
  let equipCheck = handleEquipmentNo('mech-equipmentNo', equipmentNo);
  if (!equipCheck) return { type: 'DUMMY' };

  let preparedAcres = acresCompleted(harvest.treesCovered, selectedField.treePerAcre);
  let existingAcres = previousHarvest.reduce((acc, cur) => { return acc + cur.acresCompleted; }, 0);
  let totalAcresComplete = Number(preparedAcres) + existingAcres;

  if (totalAcresComplete > selectedField.mechHarvest)
    return error(`Cannot exceed the total acres in a field.<br /> Max Acres: ${selectedField.mechHarvest} <br /> You have: ${totalAcresComplete.toFixed(2)}`);

  $('#preloader').css('display','block');

  return (dispatch) => {
    axios.post(`${ROOT_URL}/createMechHarvest`, { harvest })
      .then((res) => JSON.parse(res.request.response))
      .then((res) => {
        $('#preloader').css('display','none');
        clearForm('mechHarvest-form');
        Materialize.toast(res.msg, 4000, 'rounded green');
        dispatch({ type: CREATE_MECH_HARVEST, payload: res.harvest, submitter: harvest.submitter });
      }).catch((err) => dispatch(error(`There was an error creating a mechanical harvest. Please try again: ${err}`)));
  }
}

/**
* createMechHarvest2(): Creates a Mech harvest record
* @param {Array} harvest: harvest records to be created
* @param {Array} previousHarvest: previous harvest records for the field, round, season
* @param {Object} selectedField: Field where harvest is taking place
* @param {Object} equipmentNo: List of available equipment
* @returns {Object} harvest: New harvest record sent back to add to existing records
* @called-in: ['/components/harvest/create/mechHarvest_create.js']
**/
export function createMechHarvest2({
  harvest
}) {
  
  if (harvest.length === 0 || !harvest) return error('No harvest records exist. Add one and try again.')
  for (const h of harvest) {
    if (Number(h.acresBalance) < 0) {
      return error(`Cannot exceed the total acres in a field.<br /> Acres balance: ${h.acresBalance} for Field: ${h.field}.`);
    }
  }
  $('#preloader').css('display','block');

  return (dispatch) => {
    axios.post(`${ROOT_URL}/createMechHarvest2`, { harvest })
      .then((res) => res.data)
      .then((res) => {
        $('#preloader').css('display','none');
        clearForm('mechHarvest-form');
        Materialize.toast(res.msg, 4000, 'rounded green');
        dispatch({ type: CREATE_MECH_HARVEST });
      }).catch((err) => dispatch(error(`There was an error creating a mechanical harvest. Please try again: ${err}`)));
  }
}

/**
* prepareMechHarvest(): Prepares the mechanical harvest to review before submitting; fetches previous records for viewing & calculating
* @param {Object} harvest: Harvest record to be submitted
* @param {Object} selectedField: Field where harvest is taking place
* @param {Object} seasons: The harvest season: start date, end date, location
* @param {Object} employees: All employees who can harvest(Currently all of them)
* @returns {Object} type, payload: action and the field string
* @called-in: ['/components/harvest/create/mechHarvest_create.js','/components/harvest/manage/mechHarvest_manage.js']
**/
export function prepareMechHarvest(harvest, selectedField, seasons, employees, type) {
  const season = seasonForLocation(seasons, harvest.location);
  if (!season) return error(`No current harvest season for location ${harvest.location}.`);
  // Verify the type of action so only one function is needed
  let _type = PREPARE_MECH_HARVEST_TO_CREATE;
  if (type === 'edit') _type = PREPARE_MECH_HARVEST_TO_EDIT;

  // Fetch employee object to get id
  let emp = findEmployeeByName(harvest.employee, employees);
  if (!emp) emp = { eid: '' };
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchPreviousMechHarvest`, {
      params: { field: harvest.field, round: harvest.round, seasonId: season.id },
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => JSON.parse(res.request.response))
      .then((res) => {
        $('#preloader').css('display','none');
        let previousHarvest = res.previousHarvest;
        // If editing, filter out the record that will be updated for new calculations
        if (type === 'edit') previousHarvest = previousHarvest.filter((h) => Number(h.id) !== Number(harvest.id));

        let preparedAcres = acresCompleted(harvest.treesCovered, selectedField.treePerAcre);
        let existingAcres = previousHarvest.reduce((acc, cur) => { return acc + cur.acresCompleted; }, 0);
        let totalAcresComplete = Number(preparedAcres) + existingAcres;
        let newHarvest = {
          ...harvest,
          estimatedLbs: estimatedLbs(harvest.estLbsPerContainer, harvest.containerCount),
          acresPerHour: acresPerHour(harvest.hours, acresCompleted(harvest.treesCovered, selectedField.treePerAcre)),
          density: density(estimatedLbs(harvest.estLbsPerContainer, harvest.containerCount), harvest.treesCovered),
          acresBalance: acresBalance(totalAcresComplete, selectedField.mechHarvest),
          acresCompleted: acresCompleted(harvest.treesCovered, selectedField.treePerAcre),
          seasonId: season.id,
          eid: emp.eid,
          intervals: handleInterval(previousHarvest),
          percentComplete: percentComplete(preparedAcres, selectedField.mechHarvest)
        };
        dispatch({
          type: _type,
          payload: newHarvest,
          selectedField,
          previousHarvest
        });
      }).catch((e) => {
        $('#preloader').css('display','none');
        dispatch(error(`There was an error fetching mechanical harvest.`));
        console.error(e)
      });
  }
}

/**
* prepareMechHarvest2(): Prepares the mechanical harvest to review before submitting; fetches previous records for viewing & calculating
* @param {Object} harvest: Harvest record to be submitted
* @param {Object} selectedField: Field where harvest is taking place
* @param {Object} seasons: The harvest season: start date, end date, location
* @param {Object} employees: All employees who can harvest(Currently all of them)
* @returns {Object} type, payload: action and the field string
* @called-in: ['/components/harvest/create/mechHarvest_create.js','/components/harvest/manage/mechHarvest_manage.js']
**/
export function prepareMechHarvest2({
  harvest, 
  fields, 
  employees, 
  type
}) {
  // Verify the type of action so only one function is needed
  let _type = PREPARE_MECH_HARVEST_TO_CREATE_2;
  if (type === 'edit') _type = PREPARE_MECH_HARVEST_TO_EDIT_2;
  // Clicked prepare, nothing to be fetched without a record
  if (harvest.length === 0) {
    return {
      type: 'DUMMY'
    }
  }
  //$('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchPreviousMechHarvest2`, {
      params: { 
        fields: harvest.map((h) => h.field), 
        round: harvest[0].round, 
        seasonId: harvest[0].seasonId 
      },
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => res.data)
      .then((res) => {
        console.log(`\n ** Response ** \n`)
        const { pHarvest } = res
        console.log(pHarvest)
        //$('#preloader').css('display','none');
        const balances = batchAcresBalances(harvest, fields, pHarvest)
        let updatedHarvest = [ ...harvest ].map((h, i) => {
          const field = fields.find((f) => f.field === h.field)
          const preparedAcres = acresCompleted(h.treesCovered, field.treePerAcre)

          return { ...h,
            estimatedLbs: estimatedLbs(h.estLbsPerContainer, h.containerCount),
            acresPerHour: acresPerHour(h.hours, acresCompleted(h.treesCovered, field.treePerAcre)),
            density: density(estimatedLbs(h.estLbsPerContainer, h.containerCount), h.treesCovered),
            acresBalance: balances[i],
            acresCompleted: acresCompleted(h.treesCovered, field.treePerAcre),
            percentComplete: percentComplete(preparedAcres, field.mechHarvest)
          }
        })
       
        /*
        // If editing, filter out the record that will be updated for new calculations
        if (type === 'edit') previousHarvest = previousHarvest.filter((h) => Number(h.id) !== Number(harvest.id));
        */
       
        dispatch({
          type: _type,
          payload: updatedHarvest,
          previousHarvest: pHarvest
        })
      }).catch((e) => {
        $('#preloader').css('display','none');
        dispatch(error(`There was an error fetching mechanical harvest.`));
        console.error(e)
      });
  }
}

/**
* updateMechHarvest(): Updates a Mech harvest record
* @param {Object} harvest: harvest record to be created
* @param {Array} previousHarvest: previous harvest records for the field, round, season
* @param {Object} selectedField: Field where harvest is taking place
* @param {Object} equipmentNo: List of available equipment
* @returns {Object} harvest: New harvest record sent back to add to existing records
* @called-in: ['/components/harvest/manage/mechHarvest_manage.js']
**/
export function updateMechHarvest(harvest, previousHarvest, selectedField, equipmentNo, selectedHarvest) {
  if (harvest.field === "F525" || harvest.field ==="F520") {} // Added 9.11.25 on req from P.Salmo(Harvesting Olsen orchards)
  else {
    for (let key in harvest) {
      switch (true) {
        case (key === 'block'):
          break;
        case (key !== 'block' && key !== 'notes' && harvest[key] === ''):
          return error('Please complete the entire form.');
        default:
      }
    }
  }
  let equipCheck = handleEquipmentNo('mech-edit-equipmentNo', equipmentNo);
  if (!equipCheck) return { type: 'DUMMY' };

  let preparedAcres = acresCompleted(harvest.treesCovered, selectedField.treePerAcre);
  let existingAcres = previousHarvest.reduce((acc, cur) => { return acc + cur.acresCompleted; }, 0);
  let totalAcresComplete = Number(preparedAcres) + existingAcres;

  if (totalAcresComplete > selectedField.mechHarvest)
    return error(`Cannot exceed the total acres in a field.<br /> Max Acres: ${selectedField.mechHarvest} <br /> You have: ${totalAcresComplete.toFixed(2)}`);

  $('#preloader').css('display','block');
  harvest.id = selectedHarvest.id;

  return (dispatch) => {
    axios.put(`${ROOT_URL}/updateMechHarvest`, { harvest })
      .then((res) => {
        $('#preloader').css('display','none');
        clearForm('mechHarvest-edit-form');
        Materialize.toast(res.data.msg, 4000, 'rounded green');
        dispatch({ type: EDIT_MECH_HARVEST, payload: harvest, submitter: harvest.submitter });
      }).catch((err) => dispatch(error(`There was an error editing a mechanical harvest. Please try again ${err}`)));
  }
}

/**
* deleteMechHarvest(): Creates a Mech harvest record
* @param {Object} harvest: harvest record to be created
* @returns {Object} msg: Success of failure
* @called-in: ['/components/harvest/manage/mechHarvest_manage.js']
**/
export function deleteMechHarvest(harvest) {
  return (dispatch) => {
    axios.delete(`${ROOT_URL}/deleteMechHarvest`, { params: { harvest } })
      .then((res) => {
        $('#preloader').css('display','none');
        clearForm('mechHarvest-edit-form');
        Materialize.toast(res.data.msg, 4000, 'rounded green');
        dispatch({ type: DELETE_MECH_HARVEST, payload: res.data.id, submitter: harvest.submitter });
      }).catch((err) => dispatch(error(`There was an error editing a mechanical harvest. Please try again ${err}`)));
  }
}

/**
* fetchReport(): Fetches a report based on form selections
* @param {Object} opts:
* @returns {Object} type, payload: action and the field string
* @called-in: ['/components/harvest/view/harvest_view.js']
**/
export function fetchReport(opts, employees, email) {
  // Must select a report type
  if (opts.hand === 'on' && opts.mech === 'on') return error('Please select a report type - Hand or Mech.');
  if (opts.dateFrom === '' || opts.dateTo === '') return error('Please select dates for the report.');
  if (opts.location === '') return error('Please select a location for the report.');
  opts.eid = '';
  $('#preloader').css('display','block');
  if (opts.employee) {
    let emp = findEmployeeByName(opts.employee, employees);
    opts.eid = emp.eid;
  }
  return (dispatch) => {
    dispatch({ type: SET_REPORT_OPTS, payload: determineReportOpts(opts) });
    axios.get(`${ROOT_URL}/fetchReport`, {
      headers: { authorization: localStorage.getItem('token') },
      params: { opts, email }
    }).then((res) => {
        $('#preloader').css('display','none');
        Materialize.toast(res.data.msg, 4000, 'rounded green');
        //console.log(res.data)
        /*if (res.data.csv.status) {
          var blob = new Blob([res.data.csv.file], {type: "text/plain;charset=utf-8"});
          FileSaver.saveAs(blob, `Harvest Data Dump(${res.data.query.type}) ${opts.dateFrom}-${opts.dateTo}_${opts.location}.csv`);
        }*/
        dispatch({ type: FETCH_REPORT, payload: res.data.query, options: opts });
      }).catch((e) => {
        $('#preloader').css('display','none');
        console.error(e)
        error(`There was an error fetching a report.`);
        dispatch({ type: ERROR });
      });
  }
}

/**
* selectHarvestToManage(): Selects a harvest record to edit or delete; also fetches fields and field information
* @param {Object} h: harvest record to edit or delete
* @returns {Object} type, payload: action and the field string
* @called-in: ['/components/harvest/manage/harvest_manage.js']
**/
export function selectHarvestToManage(h) {
  //return { type: SELECT_HARVEST_TO_MANAGE, payload: h };
  return (dispatch, getState) => {
    // Quick check to see if harvest is still selected
    let { harvest } = getState();
    let employees = harvest.employees;
    if (harvest.manage.selectedHarvest.id === h.id) return { type: 'DUMMY' };
    let emp = employees.all.find((e) => e.eid === h.eid);
    if (Object.keys(emp).length > 0) h.employee = `${emp.firstName} ${emp.lastName}`;
    $('#preloader').css('display','block');
    axios.get(`${ROOT_URL}/selectHarvestToManage`, {
      params: { field: h.field },
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => {
        $('#preloader').css('display','none');
        // Dispatch data
        dispatch({ type: SELECT_HARVEST_TO_MANAGE, payload: h, selectedField: res.data.selectedField, blocks: res.data.blocks });
        // Fill Form
        fillEdit('mechHarvest-edit-form', h);
      }).catch((err) => dispatch(error(`There was an error creating a mechanical harvest. Please try again. ${err}`)));
  }
}

/**
* fetchHarvestByDate(): Fetches harvest records by date to edit or delete
* @param {String} date: date of harvest records
* @returns {Object} res.harvest: Harvest records
* @called-in: ['/components/harvest/manage/harvest_manage.js']
**/
export function fetchHarvestByDate(date) {
  let twoWeeksPrior = moment().subtract(14, 'days').format('YYYY-MM-DD');
  if (new Date(date) < new Date(twoWeeksPrior)) return error('Records past two weeks are locked and final.')
  return (dispatch) => {
    $('#preloader').css('display','block');
    axios.get(`${ROOT_URL}/fetchHarvestByDate`, {
      params: { date },
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => {
        $('#preloader').css('display','none');
        dispatch({ type: FETCH_HARVEST_BY_DATE, payload: res.data.harvest });
      }).catch((err) => dispatch(error(`There are no available mechanical harvest records for this date`)));
  }
}

/**
* selectField(): Selects a field from field list
* @param {String} field: the selected field
* @returns {Object} type, payload: action and the field string
* @called-in: ['/components/harvest/create/mechHarvest_create.js']
**/
export function selectField(field) {
  if (field === '') return { type: 'DUMMY' };
  return {
    type: SELECT_FIELD,
    payload: field
  };
}

/**
* setReportOptions(): Sets the report options to query the database; Hand, Mech choice determines different components
* @param {Object} opts: report options
* @returns {Object} type, payload: action and the field string
* @called-in: ['/components/harvest/view/harvest_view.js']
**/
export function setReportOptions(opts) {
  return {
    type: SET_REPORT_OPTS,
    payload: opts
  };
}

/**
* selectReportType(): Sets the report type; disables the
* @param {Object} opts: report options
* @returns {Object} type, payload: action and the field string
* @called-in: ['/components/harvest/view/harvest_view.js']
**/
export function selectReportType(type) {
  let _type = '';
  if (type === 'rep-hand') {
    _type = 'disabled'; // Clean up round value
    document.getElementById('rep-round').value = '';
  }
  return {
    type: SELECT_REPORT_TYPE,
    payload: _type
  };
}

/**
* selectNewReport(): Selects a new report option; reinstating the form
* @param {Boolean} reportRunning: true or false on whether a current report was run
* @returns {Object} type, payload: action and the field string
* @called-in: ['/components/harvest/view/harvest_view.js']
**/
export function selectNewReport() {
  return {
    type: SELECT_NEW_REPORT
  };
}

/**
* fetchMyMechHarvest(): Selects all mech harvest that was submitted by a user
* @param {String} eid: Employee id
* @returns {Object} type, payload: action and the field string
* @called-in: ['/components/harvest/manage/harvest_manage.js']
**/
export function fetchMyMechHarvest(eid) {
  return {
    type: FETCH_MY_MECH_HARVEST,
    payload: eid
  }
}

/**
* resetManageHarvest(): Resets or clears the state for managing harvest
* @returns {Object} type, payload: action and the field string
* @called-in: ['/components/harvest/manage/harvest_manage.js']
**/
export function resetManageHarvest() {
  clearForm('mechHarvest-edit-form');
  return {
    type: RESET_MANAGE_HARVEST
  }
}



/**
* addHarvestRecord(): Adds an individual harvest record in the mechanical harvest form
* @param {Object} harvest: individual harvest records for a single submission 
* @returns {Object} 
* @called-in: ['/components/harvest/create/mechHarvest_create.js->mechHarvest_form_2']
**/
export function addHarvestRecord(harvest) {
  
  clearForm('mechHarvest-individual-form')
  
  return {
    type: ADD_HARVEST_RECORD,
    payload: {
      ...harvest,
      guid: generateGUID()
    }
  };
}

export function setMechHarvestToEdit(harvest) {
  fillEdit2({
    formId: 'mechHarvest-individual-form', 
    form: harvest 
  })
  return {
    type: SET_MECH_HARVEST_TO_EDIT,
    payload: harvest
  }
}
/**
* editHarvestRecord(): Edits an individual harvest record in the mechanical harvest form
* @param {Object} harvest: individual harvest records for a single submission 
* @returns {Object} 
* @called-in: ['/components/harvest/create/mechHarvest_create.js->mechHarvest_form_2']
**/
export function editHarvestRecord(harvest) {
  clearForm('mechHarvest-individual-form')
  
  return {
    type: EDIT_MECH_HARVEST_RECORD,
    payload: harvest
  };
}
/**
* deleteHarvestRecord(): Deletes an individual harvest record in the mechanical harvest form
* @param {String} guid: individual harvest record unique temp id 
* @returns {Object} 
* @called-in: ['/components/harvest/create/mechHarvest_create.js->mechHarvest_form_table']
**/
export function deleteHarvestRecord(guid) {
  return {
    type: DELETE_MECH_HARVEST_RECORD,
    payload: guid
  }
}

/* END */



// WEBPACK FOOTER //
// ./src/actions/harvest_actions.js